(function () {
  'use strict';

  function isPreorder(variantData) {
    return variantData
      && variantData.policy === 'continue'
      && variantData.office <= 0
      && variantData.d <= 0;
  }

function getState(variantData, availContainer) {
  const c          = availContainer.dataset;
  const tagUnknown = c.tagUnknownStock === 'true';
  const tagAlways  = c.tagAlwaysAvailable === 'true';
  const tagInHouse = c.tagInHouse === 'true';
  const tagNoDeliveryTime = c.tagNoDeliveryTime === 'true';

  const alwaysOverride = (tagAlways || tagInHouse) && (variantData.policy !== 'deny' || variantData.office > 0 || variantData.d > 0);

  if (tagUnknown && variantData.office <= 0) return 'unknown';
  if (tagInHouse && alwaysOverride)          return 'inhouse';
  if (tagAlways  && alwaysOverride)          return 'immediate';
  if (isPreorder(variantData))               return 'preorder';
  if (variantData.office > 0)                return 'immediate';
  if (variantData.d > 0)                     return 'supplier';
  return 'unavailable';
}

function getButtonState(variantData, availContainer) {
  const c          = availContainer.dataset;
  const tagUnknown = c.tagUnknownStock === 'true';
  const tagAlways  = c.tagAlwaysAvailable === 'true';
  const tagInHouse = c.tagInHouse === 'true';

  const alwaysOverride = (tagAlways || tagInHouse) && (variantData.policy !== 'deny' || variantData.office > 0 || variantData.d > 0);

  if (tagUnknown && variantData.office <= 0) return 'unknown';
  if (tagInHouse && alwaysOverride)          return 'inhouse';
  if (tagAlways  && alwaysOverride)          return 'immediate';
  if (isPreorder(variantData))               return 'preorder';
  if (variantData.office > 0)                return 'immediate';
  if (variantData.d > 0)                     return 'supplier';
  return 'unavailable';
}

  function formatPreorderDate(dateStr) {
    if (!dateStr) return null;
    try {
      const date  = new Date(dateStr);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year  = date.getFullYear();
      return month + '/' + year;
    } catch (e) {
      return null;
    }
  }

  function addInfoButton(badge) {
    if (!badge || badge.querySelector('.avail-info-btn')) return;
    var btn = document.createElement('button');
    btn.className = 'avail-info-btn';
    btn.setAttribute('aria-label', 'Informationen zu Lieferzeiten');
    btn.setAttribute('title', 'Informationen zu Lieferzeiten');
    btn.textContent = 'i';
    btn.onclick = function () { windloungeOpenInfo(); };
    badge.appendChild(btn);
  }

  function renderBadge(badge, state, availContainer, variantData) {
    const c           = availContainer.dataset;
    const isContact   = c.tagContactShippingWorld === 'true';
    const region      = c.region;
    const showContact = isContact && region === 'world';
    const tagCustomMade = c.tagCustomMade === 'true';
const tagNoDeliveryTime = c.tagNoDeliveryTime === 'true';
const noDeliveryTimeSub = tagNoDeliveryTime ? c.subNoDeliveryTime : null;
    const supplierLabel = tagCustomMade ? 'Custom Made' : c.labelSupplier;

    const contactSub   = c.subContact;
    const preorderDate = variantData && variantData.preorder_date
      ? formatPreorderDate(variantData.preorder_date)
      : null;
    const preorderSub  = preorderDate
      ? 'Voraussichtliche Lieferung: ' + preorderDate
      : c.subPreorder;

    const officeStock    = variantData ? variantData.office : 0;
    const dStock         = variantData ? variantData.d : 0;
    const lowStockLimit  = 10;
    const noStockCount   = c.tagNoStockCount === 'true';
    const fakeStockCount = c.tagFakeStockCount === 'true';

const stockAvailable     = c.stockAvailable || 'COUNT verfügbar';
const stockAvailablePlus = c.stockAvailablePlus;

function buildStockLabel(stock) {
  if (noStockCount)                       return '';
  if (fakeStockCount)                     return stockAvailablePlus + '. ';
  if (stock >= lowStockLimit)             return stockAvailablePlus + '. ';
  if (stock > 0 && stock < lowStockLimit) return stockAvailable.replace('COUNT', stock) + '. ';
  return '';
}

    const immediateStock = buildStockLabel(officeStock);
    const supplierStock  = buildStockLabel(dStock);
    const stockLabel = state === 'unknown'
      ? ''
      : (state === 'immediate' || state === 'inhouse') ? immediateStock : supplierStock;

const configs = {
immediate: { label: c.labelImmediate, sub: noDeliveryTimeSub ?? (showContact ? contactSub : c.deliveryImmediate), mod: 'avail-badge--immediate' },
inhouse:   { label: c.labelImmediate, sub: noDeliveryTimeSub ?? (showContact ? contactSub : c.deliveryImmediate), mod: 'avail-badge--inhouse'   },
supplier:  { label: supplierLabel,    sub: noDeliveryTimeSub ?? (showContact ? contactSub : c.deliverySupplier),  mod: 'avail-badge--supplier'  },
      unavailable: { label: c.labelUnavailable, sub: showContact ? contactSub : c.subUnavailable,    mod: 'avail-badge--unavailable' },
      nonexistant: { label: c.labelNonexistant, sub: c.subNonexistant,                               mod: 'avail-badge--nonexistant' },
      preorder:    { label: c.labelPreorder,    sub: preorderSub,                                    mod: 'avail-badge--preorder'    },
      unknown:     { label: c.labelUnknown,     sub: c.subUnknown,                                   mod: 'avail-badge--unknown'     },
    };

    const cfg = configs[state];
    if (!cfg) return;
    badge.className = 'avail-badge ' + cfg.mod;
    badge.innerHTML =
      '<div class="avail-badge__text">' +
        '<span class="avail-badge__label">' + cfg.label + ': ' + cfg.sub + '</span>' +
        (stockLabel ? '<span class="avail-badge__stock">' + stockLabel + '</span>' : '') +
      '</div>';

    addInfoButton(badge);
    badge.style.visibility = 'visible';
  }

  function getSelectedOptions(optionCount) {
    const selected = {};
    for (let i = 1; i <= optionCount; i++) {
      const checked = document.querySelector('input[name="option-' + i + '"].productOption:checked');
      if (checked) selected[i] = checked.value;
    }
    return selected;
  }

  function colorOptionButtons(availData, variantMap, optionCount, availContainer) {
    const lastOptIdx      = optionCount;
    const selectedOptions = getSelectedOptions(optionCount);

    document.querySelectorAll('input[name="option-' + lastOptIdx + '"].productOption').forEach(function (input) {
      const span = input.nextElementSibling;
      if (!span) return;

      const hypothetical = Object.assign({}, selectedOptions);
      hypothetical[lastOptIdx] = input.value;

      const keyParts = [];
      for (let i = 1; i <= optionCount; i++) {
        if (hypothetical[i] != null) keyParts.push(hypothetical[i]);
      }
      const key       = keyParts.join('__');
      const variantId = variantMap[key];
      const vData     = variantId ? availData[variantId] : null;

      const newClass = !variantId || !vData
        ? 'option--unavailable'
        : 'option--' + getButtonState(vData, availContainer);

      if (!span.classList.contains(newClass)) {
        span.classList.remove('option--immediate', 'option--inhouse', 'option--supplier', 'option--unavailable', 'option--preorder', 'option--unknown');
        span.classList.add(newClass);
      }
    });
  }

  function init() {
    const dataEl = document.getElementById('variant-availability-data');
    if (!dataEl) return;

    let availData;
    try { availData = JSON.parse(dataEl.textContent); }
    catch (e) { console.warn('[WindLounge] Availability data parse error', e); return; }

    const allVariantsEl = document.getElementById('all-variants-data');
    if (!allVariantsEl) return;

    let allVariants;
    try { allVariants = JSON.parse(allVariantsEl.textContent); }
    catch (e) { return; }

    const variantMap = {};
    allVariants.forEach(function (v) {
      const key = [v.option1, v.option2, v.option3]
        .filter(function (o) { return o != null; })
        .join('__');
      variantMap[key] = String(v.id);
    });

    const optionCount = allVariants.length > 0
      ? (allVariants[0].option3 != null ? 3 : allVariants[0].option2 != null ? 2 : 1)
      : 1;

    const badge          = document.querySelector('.avail-badge');
    const availContainer = document.querySelector('.variant-availability');
    if (!availContainer) return;

    // Initial einfärben
    colorOptionButtons(availData, variantMap, optionCount, availContainer);

    // Badge initial setzen + Info-Button einfügen
    const selectedVariantEl = document.querySelector('[data-selected-variant]');
    if (badge && selectedVariantEl) {
      try {
        const sv    = JSON.parse(selectedVariantEl.textContent);
        const svId  = String(sv.id);
        const vData = availData[svId];
        if (vData) {
          renderBadge(badge, getState(vData, availContainer), availContainer, vData);
        } else {
          addInfoButton(badge);
        }
      } catch (e) {}
    } else if (badge && allVariants.length > 0) {
      // Produkt ohne Variantenauswahl — erste (einzige) Variante nehmen
      const svId  = String(allVariants[0].id);
      const vData = availData[svId];
      if (vData) {
        renderBadge(badge, getState(vData, availContainer), availContainer, vData);
      } else {
        addInfoButton(badge);
      }
    } else if (badge) {
      addInfoButton(badge);
    }

    // Yuva's variant-change Event
    document.addEventListener('variant-change', function (e) {
      const selectedOptions = getSelectedOptions(optionCount);
      const keyParts = [];
      for (let i = 1; i <= optionCount; i++) {
        if (selectedOptions[i] != null) keyParts.push(selectedOptions[i]);
      }
      const key       = keyParts.join('__');
      const variantId = variantMap[key];
      const vData     = variantId ? availData[variantId] : null;

      if (badge) {
        if (!vData) {
          renderBadge(badge, 'nonexistant', availContainer, null);
        } else {
          renderBadge(badge, getState(vData, availContainer), availContainer, vData);
        }
      }

      setTimeout(function () { colorOptionButtons(availData, variantMap, optionCount, availContainer); }, 150);
      setTimeout(function () { colorOptionButtons(availData, variantMap, optionCount, availContainer); }, 400);
      setTimeout(function () { colorOptionButtons(availData, variantMap, optionCount, availContainer); }, 800);
    });

    // Yuva's PubSub variantChange
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event.data && event.data.variant;
      if (!variant) return;

      const svId  = String(variant.id);
      const vData = availData[svId];

      if (badge) {
        if (!vData) {
          renderBadge(badge, 'nonexistant', availContainer, null);
        } else {
          renderBadge(badge, getState(vData, availContainer), availContainer, vData);
        }
      }

      setTimeout(function () { colorOptionButtons(availData, variantMap, optionCount, availContainer); }, 150);
      setTimeout(function () { colorOptionButtons(availData, variantMap, optionCount, availContainer); }, 400);
      setTimeout(function () { colorOptionButtons(availData, variantMap, optionCount, availContainer); }, 800);
    });

    // MutationObserver — fängt DOM-Änderungen durch Yuva ab
    const variantContainer = document.querySelector('.product-loop-variants');
    if (variantContainer) {
      const observer = new MutationObserver(function (mutations) {
        const relevant = mutations.some(function (m) {
          return Array.from(m.addedNodes).some(function (n) {
            return n.nodeType === 1;
          }) || m.type === 'attributes';
        });
        if (relevant) {
          setTimeout(function () {
            colorOptionButtons(availData, variantMap, optionCount, availContainer);
          }, 50);
        }
      });
      observer.observe(variantContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }
    
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  // ── Lieferzeiten-Info Overlay ────────────────────────────────────────
  var infoPageLoaded = false;

window.windloungeOpenInfo = function () {
  var locale = document.documentElement.lang || 'de';
  var pageUrl = locale.startsWith('de')
    ? '/pages/informationen-zu-lieferzeiten'
    : '/' + locale + '/pages/informationen-zu-lieferzeiten';

  var overlay = document.getElementById('avail-info-overlay');
  if (!overlay) {
    var title = document.querySelector('.variant-availability')?.dataset.infoPageTitle || 'Informationen zu Lieferzeiten';
    overlay = document.createElement('div');
    overlay.id = 'avail-info-overlay';
    overlay.className = 'avail-info-overlay';
    overlay.innerHTML =
      '<div class="avail-info-modal">' +
        '<div class="avail-info-modal__header">' +
          '<span>' + title + '</span>' +
          '<button class="avail-info-modal__close" onclick="windloungeCloseInfo()">✕</button>' +
        '</div>' +
        '<div class="avail-info-modal__content" id="avail-info-content">' +
          '<div style="padding:20px;text-align:center;color:#888;">Lädt...</div>' +
        '</div>' +
      '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) windloungeCloseInfo();
    });
    document.body.appendChild(overlay);
  }

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (!infoPageLoaded) {
      infoPageLoaded = true;
      fetch(pageUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');
        var content = doc.querySelector('.yv-page-description-wrapper');
          var el      = document.getElementById('avail-info-content');
          if (content && el) {
            el.innerHTML = content.innerHTML;
          } else if (el) {
            el.innerHTML = '<p style="padding:20px;color:#888;">Inhalt konnte nicht geladen werden.</p>';
          }
        })
        .catch(function () {
          var el = document.getElementById('avail-info-content');
          if (el) el.innerHTML = '<p style="padding:20px;color:#888;">Seite konnte nicht geladen werden.</p>';
          infoPageLoaded = false;
        });
    }
  };

  window.windloungeCloseInfo = function () {
    var overlay = document.getElementById('avail-info-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') windloungeCloseInfo();
  });

})();

// ── EU Gewährleistung Overlay ────────────────────────────────────────
var WARRANTY_SVG_URL = 'https://cdn.shopify.com/s/files/1/0610/6166/0886/files/Gro_eu-warranty-de.jpg';

window.windloungeOpenWarranty = function () {
  var overlay = document.getElementById('warranty-overlay');

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'warranty-overlay';
    overlay.className = 'warranty-overlay';
    overlay.innerHTML =
      '<div class="warranty-modal">' +
        '<div class="warranty-modal__header">' +
          '<span>Gesetzliche Gewährleistung</span>' +
          '<a class="warranty-modal__download" href="' + WARRANTY_SVG_URL + '" target="_blank" rel="noopener" download>↓ Herunterladen</a>' +
          '<button class="warranty-modal__close" onclick="windloungeCloseWarranty()">✕</button>' +
        '</div>' +
        '<div class="warranty-modal__content">' +
          '<img src="' + WARRANTY_SVG_URL + '" class="warranty-modal__img" alt="Gesetzliche Gewährleistung EU" loading="lazy" decoding="async">' +
        '</div>' +
      '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) windloungeCloseWarranty();
    });
    document.body.appendChild(overlay);
  }

  overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
};

window.windloungeCloseWarranty = function () {
  var overlay = document.getElementById('warranty-overlay');
  if (overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
};

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') windloungeCloseWarranty();
});